import { OB } from "../ob";

export declare class Controller extends OB {
    static EVENT_CHANGE: string;
}
